import React, { FunctionComponent } from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import Section from 'ui/atoms/section';
import InvestmentTableView from 'apps/issuer/pages/investor-details/investments-view/investment-table-view';

interface IssuerInvestorDetailsPageProps {
  fetchInvestorDetails: () => void;
  investorId: string;
}

const InvestmentsView: FunctionComponent<IssuerInvestorDetailsPageProps> = (props) => {
  const { investorId } = props;

  return (
    <Section>
      <WideContent title={<Translate name={'common.investments'} />} ignorePageTitle titleSpacing="medium">
        <InvestmentTableView investorId={investorId} />
      </WideContent>
    </Section>
  );
};

export default InvestmentsView;
